import * as NameSpace from '../NameSpace'
import { ParseService } from '../../Services/parse'

const state = {
  [NameSpace.AUTH_STATE]: {
    auth: {},
    error: null,
    expired: null
  },
  [NameSpace.FORGOT_PASSWORD_STATE]: {
    success: null,
    error: null
  }
}

const getters = {
  [NameSpace.AUTH_GETTER]: state => {
    return state[NameSpace.AUTH_STATE]
  },
  [NameSpace.GET_FORGOT_PASSWORD_STATUS]: state => {
    return state[NameSpace.FORGOT_PASSWORD_STATE]
  }
}

const mutations = {
  [NameSpace.AUTH_MUTATION]: (state, payload) => {
    state[NameSpace.AUTH_STATE] = payload
  },
  [NameSpace.CLEAR_AUTH_ERRORS_MUTATION]: (state, payload) => {
    state[NameSpace.AUTH_STATE].error = payload
  },
  [NameSpace.MUTATE_FORGOT_PASSWORD]: (state, payload) => {
    state[NameSpace.FORGOT_PASSWORD_STATE] = payload
  },
  [NameSpace.MUTATE_AUTH_EXPIRY]: (state, payload) => {
    state[NameSpace.AUTH_STATE].expired = payload
  }
}

const actions = {
  [NameSpace.ASYNC_AUTH_ACTION]: ({ commit }, payload) => {
    ParseService.login(payload.username, payload.password)
      .then((user) => {
        commit(NameSpace.AUTH_MUTATION, {auth: user, error: null, expired: false})
      })
      .catch((error) => {
        commit(NameSpace.AUTH_MUTATION, {auth: [], error: error, expired: null})
      })
  },
  [NameSpace.GET_USER_FROM_LOCAL_STORAGE]: ({ commit }) => {
    commit(NameSpace.AUTH_MUTATION, {
      auth: JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser') || '{}'),
      error: null,
      expired: false
    })
  },
  [NameSpace.UPDATE_AUTH_USER_FROM_PROFILE]: ({ commit }) => {
    commit(NameSpace.AUTH_MUTATION, {
      auth: JSON.parse(localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser') || '{}'),
      error: null,
      expired: false
    })
  },
  [NameSpace.CLEAR_AUTH_ERRORS_ACTION]: ({ commit }) => {
    commit(NameSpace.CLEAR_AUTH_ERRORS_MUTATION, null)
  },
  [NameSpace.RESET_PASSWORD]: ({commit}, payload) => {
    ParseService.forgotPassword(payload).then((message) => {
      commit(NameSpace.MUTATE_FORGOT_PASSWORD, {success: message, error: null})
      setTimeout(() => {
        commit(NameSpace.MUTATE_FORGOT_PASSWORD, {success: null, error: null})
      })
    })
    .catch((error) => {
      commit(NameSpace.MUTATE_FORGOT_PASSWORD, {success: {}, error: error})
      setTimeout(() => {
        commit(NameSpace.MUTATE_FORGOT_PASSWORD, {success: null, error: null})
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/authorization.js